module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qhead4-0d5d0092f08e7cffb47cf57b16eb5c51.jpg";